import React from "react";

export default function App(props) {
  return (
    // <div className="min-h-screen bg-white text-slate-900">
      <div className="">
      {/* <header className="border-b border-slate-200 p-4"> */}
        {/* <h1 className="text-2xl font-bold">
          Welcome, {props.current_user?.name || 'Guest'}
        </h1>
        <p className="text-slate-600 mt-2">
          DeepDocs AI - Accelerating Clinical Affairs
        </p> */}
      {/* </header> */}
      
      <main className="">
        {/* <div className="max-w-4xl mx-auto">
          <div className="bg-slate-50 rounded-xl border border-slate-200 p-6">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">
              React + Rails + Vite Integration
            </h2>
            <p className="text-slate-600 mb-4">
              This React component is mounted inside a Rails .erb page using Stimulus.
              The component receives props from the Rails controller and renders them here.
            </p>
            
            {props.homepage_version && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-blue-800">
                  <strong>Current homepage version:</strong> {props.homepage_version}
                </p>
              </div>
            )}
            
            {props.current_branch && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-4">
                <p className="text-green-800">
                  <strong>Deployed branch:</strong> {props.current_branch}
                  {props.is_preview && (
                    <span className="ml-2 bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-sm">
                      Preview
                    </span>
                  )}
                </p>
              </div>
            )}
          </div>
        </div> */}
      </main>
    </div>
  );
}
